import { Typography } from "@mui/material";
import { EllipsesStyle } from "../Types/IEllipsesStyle";
import { IKeyDriveFonts } from "../Types/IKeyDriveFonts";

export function KeyDriveBodyMin({
    color,
    needEllipses,
    text,
    needBold,
    required = false
}: IKeyDriveFonts) {
    return (
        <Typography
            variant="body2"
            fontFamily="SEGOE UI"
            fontSize="14px"
            lineHeight="21px"
            fontWeight={needBold ? 600 : 400}
            color={color}
            sx={needEllipses ? EllipsesStyle : {}}
            textTransform="none"
        >
            { required ? `${text} *` : text }
        </Typography>
    )
}